import { combineReducers } from 'redux';
import session from './session_reducer';
import user from './users_reducer';
import errors from './errors_reducer';
import course from './course_api_reducer';
import work from './work_api_reducer';
import introVids from "./intro_vids_reducer";
import galleryReducer from './gallery_reducer';
import hotels from "./hotels_reducer";
import fashionphotos from "./fashionphotos_reducer";

const RootReducer = combineReducers({
  session,
  user,
  errors,
  course,
  work,
  introVids,
    gallery: galleryReducer,
     hotels,
     fashionphotos,

});

export default RootReducer;